import React, { useEffect } from 'react'

const RenderVideo = ({ videoM, videoT, videoD, id = '', classList, data }) => {
  useEffect(() => {
    const mobileBreakpoint = window.matchMedia('(max-width: 767px)')
    const tabletBreakpoint = window.matchMedia('(min-width: 768px)')
    const desktopBreakpoint = window.matchMedia('(min-width: 1024px)')

    const currentVideo = document.getElementById(id)

    currentVideo.setAttribute('muted', '')

    window.addEventListener('resize', () => {
      const currentVideoSourceUpdate = currentVideo
      if (
        tabletBreakpoint.matches &&
        window.matchMedia('(max-width: 1023px').matches &&
        currentVideoSourceUpdate.getAttribute('src') !== videoT
      ) {
        currentVideoSourceUpdate.setAttribute('src', videoT)
        currentVideo.load()
      }
      if (
        desktopBreakpoint.matches &&
        currentVideoSourceUpdate.getAttribute('src') !== videoD
      ) {
        currentVideoSourceUpdate.setAttribute('src', videoD)
        currentVideo.load()
      }
      if (
        mobileBreakpoint.matches &&
        currentVideoSourceUpdate.getAttribute('src') !== videoM
      ) {
        currentVideoSourceUpdate.setAttribute('src', videoM)
        currentVideo.load()
      }
    })

    window.addEventListener('focus', () => {
      currentVideo.play()
    })
    window.addEventListener('blur', () => {
      currentVideo.pause()
    })

    changeSource(
      videoM,
      videoT,
      videoD,
      currentVideo,
      mobileBreakpoint,
      tabletBreakpoint,
      desktopBreakpoint
    )
  })

  const changeSource = (
    videoMobile,
    videoTablet,
    videoDesktop,
    currentVideo,
    mobileBreakpoint,
    tabletBreakpoint,
    desktopBreakpoint
  ) => {
    if (
      tabletBreakpoint.matches &&
      window.matchMedia('(max-width: 1023px').matches &&
      currentVideo.getAttribute('src') !== videoTablet
    ) {
      currentVideo.setAttribute('src', videoTablet)
      currentVideo.load()
    }
    if (
      desktopBreakpoint.matches &&
      currentVideo.getAttribute('src') !== videoDesktop
    ) {
      currentVideo.setAttribute('src', videoDesktop)
      currentVideo.load()
    }
    if (
      mobileBreakpoint.matches &&
      currentVideo.getAttribute('src') !== videoMobile
    ) {
      currentVideo.setAttribute('src', videoMobile)
      currentVideo.load()
    }
  }

  return (
    <video
      id={id}
      preload='yes'
      loop
      playsInline
      autoPlay
      muted
      disableRemotePlayback
      className={classList}
      data-video={data}
      src=''
      type='video/mp4'
    />
  )
}

export default RenderVideo
